import { DateTime } from 'luxon';

export enum FilterOperator {
  IS = 'is',
  IS_NOT = 'isNot',
  CONTAINS = 'contains',
  AFTER = 'after',
  BEFORE = 'before',
  BETWEEN = 'between',
}
export enum FilterType {
  TEXT = 'text',
  SELECT = 'select',
  DATE = 'date',
  ARRAY = 'array',
  NUMBER = 'number',
}

export type FilterConfiguration =
  | {
      filter: string;
      label: string;
      type: FilterType.TEXT | FilterType.DATE | FilterType.NUMBER | FilterType.ARRAY;
      operators: FilterOperator[];
      unique: boolean;
    }
  | {
      filter: string;
      label: string;
      type: FilterType.SELECT;
      operators: FilterOperator[];
      options: { label: string; value: string }[];
      unique: boolean;
    };

export interface FilterForm {
  filter: string | null;
  operator: FilterOperator | null;
  type: FilterType | null;
  value: string | number | null;
  valueFrom: DateTime | null;
  valueTo: DateTime | null;
}

export type Filter =
  | {
      id?: string;
      filter: string;
      label?: string;
      operator: FilterOperator;
      type: FilterType.TEXT;
      value: string;
    }
  | {
      id?: string;
      filter: string;
      label?: string;
      operator: FilterOperator;
      type: FilterType.SELECT;
      value: string;
      optionLabel?: string;
    }
  | {
      id?: string;
      filter: string;
      label?: string;
      operator: FilterOperator;
      type: FilterType.NUMBER;
      value: number;
    }
  | {
      id?: string;
      filter: string;
      label?: string;
      operator: FilterOperator;
      type: FilterType.DATE;
      valueFrom?: DateTime;
      valueTo?: DateTime;
    }
  | {
      id?: string;
      filter: string;
      label?: string;
      operator: FilterOperator;
      type: FilterType.ARRAY;
      value: string[];
    };
